export default {"src":"/_next/static/media/security-assessment.c7e075b3.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};